export const ALL_FRANCHISES = "all";

const isPicked = (franchiseId) =>
  franchiseId !== undefined &&
  franchiseId !== null &&
  franchiseId !== "" &&
  franchiseId !== ALL_FRANCHISES;

export const franchiseParams = (isSuperuser, franchiseId) =>
  isSuperuser && isPicked(franchiseId)
    ? `franchise_id=${encodeURIComponent(franchiseId)}`
    : "";

export const tileSet = (isSuperuser, franchiseId) => {
  if (!isSuperuser) return "own";
  return isPicked(franchiseId) ? "franchise" : "all";
};

export const franchiseOptions = (franchises) => [
  { value: ALL_FRANCHISES, label: "All franchises" },
  ...(Array.isArray(franchises) ? franchises : []).map((f) => ({
    value: String(f.id),
    label: f.name,
  })),
];
